import { render } from "./WidePhotoComponent.vue?vue&type=template&id=3317fc8a"
import script from "./WidePhotoComponent.vue?vue&type=script&lang=js"
export * from "./WidePhotoComponent.vue?vue&type=script&lang=js"

import "./WidePhotoComponent.vue?vue&type=style&index=0&id=3317fc8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__